import z from "zod"
import { OrderInformationSchema } from "../orderInformation"

export const BigBlueIntegrationResponseDataSchema = z.object({
  token: z.string().nullish(),
  prefix: z.string().nullish(),
  webhooksSecretKey: z.string().nullish(),
  webhooksVerifiedAt: z
    .date()
    .nullish()
    .transform((value) => value?.toISOString()),
})

export const GetBigBlueOrderResponseDataSchema = OrderInformationSchema
